const eventRegisterButton = {

  corro_ninos_2026: {

    evento: "corro_ninos_2026",

    imagen:
      "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/1.jpg?updatedAt=1790178115023",

    titulo:
      "INSCRIPCIÓN INDIVIDUAL",

    descripcion:
      "Sé parte de Yo Corro por los Niños 2026. Completa tu inscripción y prepárate para vivir una experiencia llena de deporte, emoción y solidaridad.",

    texto:
      "INSCRÍBETE AHORA"

  },


  corro_ninos_2026_mascotas: {

    evento: "corro_ninos_2026_mascotas",

    imagen:
      "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/5.jpg",

    titulo:
      "INSCRIBIRME JUNTO A MI MASCOTA",

    descripcion:
      "Únete a la carrera junto a tu mascota y comparte momentos inolvidables. Completa tu inscripción y prepárate para vivir una experiencia llena de deporte, emoción y solidaridad.",

    texto:
      "INSCRÍBETE AHORA"

  },


};

export default eventRegisterButton;